export default "__VITE_ASSET__B2cOZypA__"